export default __webpack_public_path__ + "static/media/delete.2a0324cb.svg";